import { render, staticRenderFns } from "./versionEdit.vue?vue&type=template&id=2c4253a8&"
import script from "./versionEdit.vue?vue&type=script&lang=js&"
export * from "./versionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports